import {
  isFinishAtType,
  isRemainingTimeType,
} from "@circle-react/helpers/paywallCustomizationHelpers";
import { type PaywallCustomization } from "@circle-react/types/PaywallCustomization";
import { formatCountdownTimer } from "../helpers";

interface UseCountdownPreviewProps {
  countdownProperties: PaywallCustomization["countdown_properties"];
}

export const useCountdownPreview = ({
  countdownProperties,
}: UseCountdownPreviewProps) => {
  let timeRemainingText = "";

  if (isRemainingTimeType(countdownProperties.countdown_type)) {
    timeRemainingText = `${countdownProperties.remaining_time}m : 0s`;
  }

  if (isFinishAtType(countdownProperties.countdown_type)) {
    timeRemainingText = formatCountdownTimer(
      countdownProperties.finish_at || new Date().toISOString(),
    );
  }

  return {
    timeRemainingText,
  };
};
